<script lang="ts" setup>
import { useBlockingOnce } from "~/composables/local/once"

definePageMeta({
	layout: "website",
})

useHead({
	title: "هوش مصنوعی Tuka | خانه",
})

const gql = useGql()
const api = useApi()

const [website, subs] = await useBlockingOnce(() => Promise.all([
	getWebsiteData(),
	readSubscriptions(),
]))

async function getWebsiteData() {
	return await gql.query({
		home: [{}, {
			heroTip: true,
			usecase: [{}, {
				id: true,
				title: true,
				description: true,
				image: {
					url: true,
				},
			}],
			faq: [{}, {
				answer: true,
				id: true,
				question: true,
			}],
		}],
		blogs: [{
			sort: ["createdAt:DESC"],
			pagination: {
				page: 1,
				pageSize: 3,
			},
		}, {
			title: true,
			slug: true,
			createdAt: true,
			category: {
				name: true,
			},
			image: {
				url: true,
			},
			writer: {
				name: true,
				image: {
					url: true,
				},
			},
		}],
	})
}

async function readSubscriptions() {
	const { data: response } = await api.subscription.readLimitedSubscriptions({})
	return response.data
}
</script>

<template>
	<div class="relative">
		<HeroSection
			class="z-1"
			:banner="website.home?.heroTip" />

		<FeaturesSection />

		<UsecaseSection :data="website.home?.usecase" />

		<WebsitePlansSection :data="subs" />

		<BlogSection :data="website.blogs" />

		<FaqSection :data="website.home?.faq" />

		<CtaSection />
	</div>
</template>
